import * as stylex from '@stylexjs/stylex';
import { forwardRef } from 'react';
import { Icon, type IconProps } from '../IconShell';
import { iconsStyles } from '../styles';
export const LinkedinIcon = forwardRef<SVGSVGElement, Partial<IconProps>>(function LinkedinIcon({
  styles,
  ...props
}, ref) {
  return <Icon styles={styles} viewBox="0 0 24 24" title="Linkedin" description="Linkedin Logo" ref={ref} {...props}>
        <path {...stylex.props([iconsStyles.neutralElement])} d="M23 0H1C.4 0 0 .4 0 1v22c0 .6.4 1 1 1h22c.6 0 1-.4 1-1V1c0-.6-.4-1-1-1zM3.6 20.5V9h3.6v11.5H3.6zM5.3 7.4c-1.1 0-2.1-.9-2.1-2.1 0-1.1.9-2.1 2.1-2.1 1.1 0 2.1.9 2.1 2.1a2 2 0 01-2.1 2.1zm15.2 13.1h-3.6v-5.6c0-1.3 0-3-1.8-3-1.9 0-2.1 1.4-2.1 2.9v5.7H9.4V9h3.4v1.6c.5-.9 1.6-1.8 3.4-1.8 3.6 0 4.3 2.4 4.3 5.5v6.2z" />
      </Icon>;
});